import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

import Spinner from "./Spinner/Spinner"
import SingleQuote from "./SingleQuote"

const QuoteOfTheDay = () => {
  const [quote, setQuote] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchQuote = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_QUOTE_DAY}`
      );
      setQuote(response.data[0]);
      setKeywords(response.data[0].keywords)
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    fetchQuote();
  }, []);

  if(loading) {
    return (<div className="h-screen"><Spinner/></div>)
  } else {
  
    return (
      <div className="sm:mb-10 md:mb-12">
        <h1 className="flex justify-center text-center mb-10 mt-3 text-2xl text-gray-800 italic font-bold py-2 px-4">
          Quote of the Day: {moment().format("dddd LL")}
        </h1>
        <SingleQuote singleQuote={quote} singleQuoteKeywords={keywords}/>
      </div>
    );
  }
};

export default QuoteOfTheDay;
